import React, { useEffect, useState } from 'react';
import connect from '@app/utils/connect';
import { LoadingDots } from '@app/ui';
import { useParams } from 'react-router-dom';
import ExposureDetails from '@app/broadcasts/components/exposures/ExposureDetails';
import filterActions from '@app/actions/filters';
import {
    getModifiedBroadcast,
    getFiltersToSave,
    findBroadcastRspByRouteParams,
} from '@app/broadcasts/utils/broadcastsUtils';
import { parseEndDate, parseStartDate } from '@app/utils/parseDate';

interface ExposureWrapperProps {
    filters: any;
    broadcasts: any;
    saveFilters: (newFilters: any) => void;
}

const ExposureWrapper = ({
    filters,
    broadcasts,
    saveFilters,
}: ExposureWrapperProps) => {
    const [isloadingFilters, setIsloadingFilters] = useState(false);
    const {
        broadcastName: id,
        contentDate: broadcastDate,
        rightsholderId,
        sponsorId,
        placementId,
    } = useParams();
    const { rightsholders, sponsors, placements } = filters;
    const broadcast = getModifiedBroadcast(filters, broadcasts, id);
    const currentRsp = findBroadcastRspByRouteParams(broadcast?.broadcastRsps, {
        rightsholderId,
        sponsorId,
        placementId,
    });

    useEffect(() => {
        const start = parseStartDate(broadcastDate);
        const end = parseEndDate(broadcastDate);
        const newFilters = getFiltersToSave({
            ...filters,
            startDate: start,
            endDate: end,
            rightsholders: {
                ...rightsholders,
                selected: [rightsholderId],
            },
            sponsors: {
                ...sponsors,
                selected: [sponsorId],
            },
            placements: {
                ...placements,
                selected: [`${rightsholderId}-${placementId}`],
            },
        });
        let updateFilters = false;

        if (broadcast) {
            if (!currentRsp) {
                updateFilters = true;
            }
        } else {
            updateFilters = true;
        }

        if (updateFilters) {
            setIsloadingFilters(true);
            saveFilters(newFilters);
            setIsloadingFilters(false);
        }
    }, [broadcast, broadcastDate]);

    if (isloadingFilters || !broadcast || !currentRsp) {
        return <LoadingDots size="lg" className="-p-t-6 -m-t-6" />;
    }

    return <ExposureDetails />;
};

export default connect(
    ['broadcasts', 'filters'],
    filterActions,
)(ExposureWrapper);
